import zIndexLevel from "@mittwald/flow-lib/dist/lib/zIndexLevel";
import { css } from "styled-components";
import { breakpointProp } from "./breakpointProp";
import { px } from "./formatters";
import { marginMixinPropsType } from "./margin";
export const positionMixinProps = marginMixinPropsType.complete({
    _dangerouslySetZIndex: true,
    _bottom: true,
    _left: true,
    _position: true,
    _top: true,
    _right: true,
});
const absolutePositioningCss = css `
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
`;
export const positionMixin = css `
  ${breakpointProp("_top", (top) => css `
      top: ${px(top)};
    `)};

  ${breakpointProp("_left", (left) => css `
      left: ${px(left)};
    `)};

  ${breakpointProp("_bottom", (bottom) => css `
      bottom: ${px(bottom)};
    `)};

  ${breakpointProp("_right", (right) => css `
      right: ${px(right)};
    `)};

  ${breakpointProp("_position", (position) => {
    if (position === "centerAbsolute") {
        return css `
        ${absolutePositioningCss};
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      `;
    }
    if (position === "overlay" || position === "fixedOverlay") {
        return css `
        z-index: ${zIndexLevel.portal};
        position: ${position === "overlay" ? "absolute" : "fixed"};
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      `;
    }
    return css `
      position: ${position};
    `;
})};

  ${breakpointProp("_dangerouslySetZIndex", (zIndex) => css `
      z-index: ${zIndex};
    `)};
`;
export default positionMixin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zaXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWl4aW5zL3Bvc2l0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sV0FBVyxNQUFNLHlDQUF5QyxDQUFDO0FBQ2xFLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUN4QyxPQUFPLEVBQUUsY0FBYyxFQUFzQixNQUFNLGtCQUFrQixDQUFDO0FBQ3RFLE9BQU8sRUFBRSxFQUFFLEVBQUUsTUFBTSxjQUFjLENBQUM7QUFDbEMsT0FBTyxFQUFFLG9CQUFvQixFQUFvQixNQUFNLFVBQVUsQ0FBQztBQXdDbEUsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQzdCLG9CQUFvQixDQUFDLFFBQVEsQ0FBcUI7SUFDaEQscUJBQXFCLEVBQUUsSUFBSTtJQUMzQixPQUFPLEVBQUUsSUFBSTtJQUNiLEtBQUssRUFBRSxJQUFJO0lBQ1gsU0FBUyxFQUFFLElBQUk7SUFDZixJQUFJLEVBQUUsSUFBSTtJQUNWLE1BQU0sRUFBRSxJQUFJO0NBQ2IsQ0FBQyxDQUFDO0FBRUwsTUFBTSxzQkFBc0IsR0FBRyxHQUFHLENBQUE7Ozs7O0NBS2pDLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsR0FBRyxDQUFvQjtJQUNoRCxjQUFjLENBQ2QsTUFBTSxFQUNOLENBQUMsR0FBRyxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUE7YUFDSCxFQUFFLENBQUMsR0FBRyxDQUFDO0tBQ2YsQ0FDRjs7SUFFQyxjQUFjLENBQ2QsT0FBTyxFQUNQLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUE7Y0FDSCxFQUFFLENBQUMsSUFBSSxDQUFDO0tBQ2pCLENBQ0Y7O0lBRUMsY0FBYyxDQUNkLFNBQVMsRUFDVCxDQUFDLE1BQU0sRUFBRSxFQUFFLENBQUMsR0FBRyxDQUFBO2dCQUNILEVBQUUsQ0FBQyxNQUFNLENBQUM7S0FDckIsQ0FDRjs7SUFFQyxjQUFjLENBQ2QsUUFBUSxFQUNSLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUE7ZUFDSCxFQUFFLENBQUMsS0FBSyxDQUFDO0tBQ25CLENBQ0Y7O0lBRUMsY0FBYyxDQUFDLFdBQVcsRUFBRSxDQUFDLFFBQVEsRUFBRSxFQUFFO0lBQ3pDLElBQUksUUFBUSxLQUFLLGdCQUFnQixFQUFFLENBQUM7UUFDbEMsT0FBTyxHQUFHLENBQUE7VUFDTixzQkFBc0I7Ozs7T0FJekIsQ0FBQztJQUNKLENBQUM7SUFFRCxJQUFJLFFBQVEsS0FBSyxTQUFTLElBQUksUUFBUSxLQUFLLGNBQWMsRUFBRSxDQUFDO1FBQzFELE9BQU8sR0FBRyxDQUFBO21CQUNHLFdBQVcsQ0FBQyxNQUFNO29CQUNqQixRQUFRLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLE9BQU87Ozs7Ozs7O09BUTFELENBQUM7SUFDSixDQUFDO0lBRUQsT0FBTyxHQUFHLENBQUE7a0JBQ0ksUUFBUTtLQUNyQixDQUFDO0FBQ0osQ0FBQyxDQUFDOztJQUVBLGNBQWMsQ0FDZCx1QkFBdUIsRUFDdkIsQ0FBQyxNQUFNLEVBQUUsRUFBRSxDQUFDLEdBQUcsQ0FBQTtpQkFDRixNQUFNO0tBQ2xCLENBQ0Y7Q0FDRixDQUFDO0FBRUYsZUFBZSxhQUFhLENBQUMifQ==